import { LogisticaManifiestoProformaEstado } from "@pcgerente-node/pcg-comun";
import { CIUDAD, logistica_MANIFIESTO_PROFORMA } from "@pcgerente-node/pcg-comun/dist/DTOs";
import React from "react";
import { GoLinkExternal } from "react-icons/go";
import { Link } from "react-router-dom";
import style from "../../../styles/paged.module.css";
import { StylesProps2, stylesProps1 } from "./styles";

interface ChildProps {
    manifiestosProforma: logistica_MANIFIESTO_PROFORMA[],
    ciudades: CIUDAD[]
}


const TablaManifiestosProforma: React.FC<ChildProps> = ({ manifiestosProforma, ciudades }) => {
    return (
        <table id={"tablaBlock"} className="table table-responsive" >
            <thead>
                <tr style={StylesProps2}>
                    <th>
                        <div className="th-content" style={stylesProps1}>#Manifiesto</div>
                    </th>
                    <th>
                        <div className="th-content" style={stylesProps1}>fecha de Emision</div>
                    </th>
                    <th>
                        <div className="th-content" style={stylesProps1}>Creado Por</div>
                    </th>
                    <th>
                        <div className="th-content" style={stylesProps1}>Origen</div>
                    </th>
                    <th>
                        <div className="th-content" style={stylesProps1}>Destino</div>
                    </th>
                    <th>
                        <div className="th-content" style={stylesProps1}>Estado</div>
                    </th>
                    <th>
                        <div className="th-content" style={stylesProps1}>Ver</div>
                    </th> 
                </tr>
            </thead>
            <tbody className="ContainerGuiasTable">
                { manifiestosProforma.map((mp)  =>  {
                    return(
                        <tr className={style.selectGuia} key={mp.id}>
                            <td>
                            <div className="td-content Capitalize">{mp.serie1}-{mp.serie2}-{mp.numeroDocumento}</div>
                            </td>
                        <td>
                                <div className="td-content Capitalize">{new Date(mp.fechaEmision?? '')?.toLocaleString()}</div>
                        </td>

                        <td>
                            <div className="td-content ">{mp.LS_usuarioCreacion}</div>
                        </td>

                        <td>
                            <div className="td-content Capitalize">{ciudades.filter(ciudad => ciudad.id === mp.idCiudadOrigen)[0].nombre}</div>
                        </td>

                        <td>
                            <div className="td-content Capitalize ">{ciudades.filter(ciudad => ciudad.id === mp.idCiudadDestino)[0].nombre}</div>
                        </td>

                        <td>
                            {mp.estado === LogisticaManifiestoProformaEstado.Pendiente?
                            <div className="td-content product-invoice Capitalize">Pendiente</div>
                            : mp.estado === LogisticaManifiestoProformaEstado.Convertido?
                            <div className="td-content product-invoice Capitalize">Convertido</div>
                            : mp.estado === LogisticaManifiestoProformaEstado.Anulado?
                            <div className="td-content product-invoice Capitalize">Anulado</div>
                            :<div className="td-content product-invoice Capitalize">??</div>
                            }
                        </td>

                        <td>
                        <Link to={`/home/consulta/resumenGuias/detalles/${mp.id}`} target="_blank"  rel="noopener noreferrer" className={style.externalLink}>
                            <GoLinkExternal/>
                        </Link>
                        </td>
                    </tr>
                    )
                    })
                }
            </tbody>
        </table>
    )

}

export default TablaManifiestosProforma